import React from 'react'
import { conductorHelpEntries, type ConductorHelpScreen } from './conductorHelp'

const ConductorFieldKey: React.FC<{ screen: ConductorHelpScreen }> = ({ screen }) => {
  const entries = conductorHelpEntries(screen)
  if (entries.length === 0) {
    return null
  }

  return (
    <details className="mt-2 text-xs text-slate-600 dark:text-slate-300">
      <summary className="cursor-pointer font-medium text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200">
        Field key
      </summary>
      <dl className="mt-2 max-w-3xl space-y-2">
        {entries.map(({ term, definition }) => (
          <div key={term}>
            <dt className="font-semibold text-slate-700 dark:text-slate-200">{term}</dt>
            <dd className="mt-0.5 text-slate-600 dark:text-slate-400">{definition}</dd>
          </div>
        ))}
      </dl>
    </details>
  )
}

export default ConductorFieldKey
